import { Quote } from "lucide-react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { SectionHeading, Reveal } from "@/components/Reveal";
import { TESTIMONIALS } from "@/data/content";

export const Testimonials = () => {
  return (
    <section
      className="py-16 sm:py-20 lg:py-24 bg-card/40 border-y border-border"
      data-testid="testimonials-section"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Client Voices"
          title="Trusted by owners who expect results"
        />

        <Reveal className="mt-12">
          <Carousel opts={{ align: "start", loop: true }} className="w-full">
            <CarouselContent className="-ml-4">
              {TESTIMONIALS.map((t) => (
                <CarouselItem key={t.name} className="pl-4 md:basis-1/2" data-testid="testimonial-card">
                  <figure className="card-highlight h-full rounded-2xl bg-card/80 border border-border p-7 flex flex-col">
                    <Quote className="w-6 h-6 text-primary/60 mb-4" />
                    <blockquote className="font-editorial text-base sm:text-lg leading-relaxed text-foreground/90 italic flex-1">
                      “{t.quote}”
                    </blockquote>
                    <figcaption className="mt-6 pt-5 border-t border-border">
                      <p className="text-sm font-semibold text-foreground">{t.name}</p>
                      <p className="text-xs uppercase tracking-widest text-muted-foreground mt-1">
                        {t.role}
                      </p>
                    </figcaption>
                  </figure>
                </CarouselItem>
              ))}
            </CarouselContent>
            <div className="flex items-center gap-3 mt-7">
              <CarouselPrevious
                className="static translate-y-0 bg-secondary border-border hover:bg-secondary/70 text-foreground"
                data-testid="testimonials-prev-button"
              />
              <CarouselNext
                className="static translate-y-0 bg-secondary border-border hover:bg-secondary/70 text-foreground"
                data-testid="testimonials-next-button"
              />
            </div>
          </Carousel>
        </Reveal>
      </div>
    </section>
  );
};
